/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsDomainPreverifiedQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  domain: GraphQL.Scalars['String']['input'];
}>;


export type IsDomainPreverifiedQuery = { readonly __typename?: 'Query', readonly isDomainPreverified: { readonly __typename?: 'DomainPreverifiedStatus', readonly isPreverified: boolean } | null };


export const IsDomainPreverifiedDocument = gql`
    query IsDomainPreverified($accountId: AccountId!, $domain: String!) {
  isDomainPreverified(accountId: $accountId, domain: $domain) {
    isPreverified
  }
}
    `;

/**
 * __useIsDomainPreverifiedQuery__
 *
 * To run a query within a React component, call `useIsDomainPreverifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDomainPreverifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDomainPreverifiedQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useIsDomainPreverifiedQuery(baseOptions: Apollo.QueryHookOptions<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables> & ({ variables: IsDomainPreverifiedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>(IsDomainPreverifiedDocument, options);
      }
export function useIsDomainPreverifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>(IsDomainPreverifiedDocument, options);
        }
export function useIsDomainPreverifiedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>(IsDomainPreverifiedDocument, options);
        }
export type IsDomainPreverifiedQueryHookResult = ReturnType<typeof useIsDomainPreverifiedQuery>;
export type IsDomainPreverifiedLazyQueryHookResult = ReturnType<typeof useIsDomainPreverifiedLazyQuery>;
export type IsDomainPreverifiedSuspenseQueryHookResult = ReturnType<typeof useIsDomainPreverifiedSuspenseQuery>;
export type IsDomainPreverifiedQueryResult = Apollo.QueryResult<IsDomainPreverifiedQuery, IsDomainPreverifiedQueryVariables>;